import styled, { css } from 'styled-components';
import colours from 'theme/atoms/colours';
import typography from 'theme/atoms/typography';
import * as Buttons from 'theme/components/Buttons.style';
import { BaseCard } from 'theme/components/Cards.style';
import * as Text from 'theme/components/Text.style';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

export const Card = styled(BaseCard)`
  gap: 15px;
  border-radius: 40px;
`;

export const SuggestionHint = styled(Buttons.Ghost)`
  background-color: ${colours.neutral[100]};
  border: 2px solid ${colours.neutral[200]};
  color: ${colours.neutral[600]};
  cursor: default;
  font-size: 14px;
  font-weight: 500;

  &:hover,
  &:focus {
    background-color: ${colours.neutral[100]};
  }
`;

export const Header = styled.div`
  align-items: center;
  color: ${colours.error[500]};
  display: flex;
  gap: 5px;
  width: 100%;

  svg {
    height: 18px;
    width: 18px;
  }

  svg path {
    stroke: currentColor;
  }
`;

export const HeaderLabel = styled(Text.P1Bold)`
  color: inherit;
  line-height: 16px;
  white-space: nowrap;
`;

export const Question = styled(Text.P2Bold)`
  color: ${colours.neutral[900]};
  width: 100%;
`;

export const BinaryRow = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const BinaryButton = styled(Buttons.SecondaryDark)<{
  $selected: boolean;
}>`
  flex: 1 0 0;
  max-width: 230px;
  min-width: 80px;
  width: auto;

  ${({ $selected }) =>
    !$selected &&
    css`
      background-color: transparent;
      border: 2px solid ${colours.neutral[200]};
      color: ${colours.neutral[900]};

      svg path {
        stroke: ${colours.neutral[900]};
      }

      &:hover,
      &:focus {
        background-color: transparent;
        border-color: ${colours.neutral[300]};
      }
    `}
`;

const pillInputBase = css`
  ${typography.p2}
  background-color: ${colours.shade[0]};
  border: 2px solid ${colours.neutral[200]};
  box-sizing: border-box;
  width: 100%;
`;

export const DatePill = styled.button`
  ${pillInputBase}
  align-items: center;
  border-radius: 30px;
  color: ${colours.neutral[900]};
  cursor: pointer;
  display: flex;
  gap: 10px;
  min-width: 200px;
  padding: 15px 15px 15px 20px;
  text-align: left;

  &:hover,
  &:focus {
    border-color: ${colours.neutral[300]};
  }
`;

export const DatePillValue = styled.span<{ $isPlaceholder: boolean }>`
  color: ${({ $isPlaceholder }) =>
    $isPlaceholder ? colours.neutral[500] : colours.neutral[900]};
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DatePillIcon = styled.span`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 20px;
  justify-content: center;
  width: 20px;

  svg {
    height: 20px;
    width: 20px;
  }

  svg path {
    stroke: ${colours.neutral[900]};
  }
`;

export const TextArea = styled.textarea`
  ${pillInputBase}
  border-radius: 25px;
  color: ${colours.neutral[900]};
  display: block;
  height: 150px;
  min-width: 200px;
  padding: 15px 20px;
  resize: none;

  &::placeholder {
    color: ${colours.neutral[500]};
  }

  &:focus {
    border-color: ${colours.neutral[300]};
    outline: none;
  }
`;

export const Pagination = styled.div`
  align-items: center;
  display: flex;
  gap: 15px;
  width: 100%;
`;

export const NavButton = styled(Buttons.SecondaryLightIcon)`
  flex-shrink: 0;
`;

export const SubmitButton = styled(Buttons.PrimaryIcon)`
  flex-shrink: 0;
`;

export const ProgressTrack = styled.div`
  display: flex;
  flex: 1 0 0;
  gap: 4px;
  min-width: 0;
`;

export const ProgressSegment = styled.div`
  background-color: ${colours.neutral[200]};
  border-radius: 3px;
  flex: 1 0 0;
  height: 4px;
  min-width: 0;
  overflow: hidden;
  position: relative;
`;

export const ProgressFill = styled.div<{ $filled: boolean }>`
  background-color: ${colours.neutral[900]};
  border-radius: 3px;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  transition: width 300ms ease;
  width: ${({ $filled }) => ($filled ? '100%' : '0%')};
`;

export const ErrorMessage = styled(Text.P2)`
  color: ${colours.error[500]};
  width: 100%;
`;
